var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrust4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_814_15249)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 24H24V28H14V24ZM34 16H14V20H34V16ZM34 8H14V12H34V8ZM40 38.888V48L36 44L32 48V38.888C30.4747 38.0116 29.282 36.6555 28.6076 35.0307C27.9333 33.406 27.8151 31.6038 28.2716 29.9049C28.728 28.206 29.7335 26.7058 31.1313 25.6378C32.5291 24.5697 34.2409 23.9939 36 24C36.6761 24.0084 37.3483 24.1039 38 24.284V6C38 5.46957 37.7893 4.96086 37.4142 4.58579C37.0391 4.21071 36.5304 4 36 4H12C11.4696 4 10.9609 4.21071 10.5858 4.58579C10.2107 4.96086 10 5.46957 10 6V40H28V44H6V6C6 4.4087 6.63214 2.88258 7.75736 1.75736C8.88258 0.632141 10.4087 0 12 0L36 0C37.5913 0 39.1174 0.632141 40.2426 1.75736C41.3679 2.88258 42 4.4087 42 6V26.764C42.7834 27.6438 43.3602 28.6877 43.688 29.8192C44.0159 30.9507 44.0865 32.1412 43.8948 33.3035C43.703 34.4659 43.2538 35.5706 42.5799 36.5369C41.906 37.5031 41.0245 38.3064 40 38.888ZM40 32C40 31.2089 39.7654 30.4355 39.3259 29.7777C38.8864 29.1199 38.2616 28.6072 37.5307 28.3045C36.7998 28.0017 35.9956 27.9225 35.2196 28.0769C34.4437 28.2312 33.731 28.6122 33.1716 29.1716C32.6122 29.731 32.2312 30.4437 32.0769 31.2196C31.9225 31.9956 32.0017 32.7998 32.3045 33.5307C32.6072 34.2616 33.1199 34.8864 33.7777 35.3259C34.4355 35.7654 35.2089 36 36 36C37.0609 36 38.0783 35.5786 38.8284 34.8284C39.5786 34.0783 40 33.0609 40 32Z",
    fill: "#843ECA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_814_15249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust4);
export default __webpack_public_path__ + "static/media/trust4.de0c91c1909df5779e4c063985406528.svg";
export { ForwardRef as ReactComponent };